import { ShieldOff } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function AccessDenied() {
  return (
    <div className="max-w-xl mx-auto pt-16 text-center" data-testid="access-denied-screen">
      <div className="mx-auto h-11 w-11 flex items-center justify-center bg-red-50 text-red-600"><ShieldOff size={22} /></div>
      <h2 className="mt-4 text-xl font-heading font-bold text-slate-900">You do not have access to this page</h2>
      <p className="mt-2 text-sm text-slate-600">Ask an administrator to grant the required page permission.</p>
      <Button asChild className="mt-5 bg-[#0A838A] hover:bg-[#076D74] font-bold"><Link to="/dashboard" data-testid="access-denied-dashboard-link">Return to dashboard</Link></Button>
    </div>
  );
}